import React, { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';

import {
  Button,
  Popover
} from '@mui/material';

import { ChromePicker } from 'react-color';

import {
  Typography
} from '../../components/interface';

var he = require('he');

type StyledColourPickerProps = {
  sx?: object;
  label?: string;
  value: string;
  onChange: (z:string) => void;
};

export const StyledColourPicker: FunctionComponent<StyledColourPickerProps> = ({onChange, value, label}) => {
  // const theme = useTheme();

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [actualValue, setActualValue] = useState<{r:number, g:number,b:number,a?:number}>({r: 0, g: 0, b: 0, a: 1});
  const [rgbValue, setRgbValue] = useState<string>(value || 'rgba(0, 0, 0, 1)');

  useEffect(() => {
    // console.log('go!');
    if (!!onChange) onChange(rgbValue);
  }, [rgbValue]);

  useEffect(() => {
    setRgbValue(`rgba(${actualValue.r}, ${actualValue.g}, ${actualValue.b}, ${actualValue.a || 1})`);
  }, [actualValue]);

  useEffect(() => {
    let r = 0;
    let g = 0;
    let b = 0;
    let a = 1;
    if (!!value) {
      let second_part = value.replace(")", "").split("(")[1];
      if (!!second_part) {
        let values = second_part.split(",").map(v => parseInt(v.trim(), 10));
        // console.log(values);
        r = values[0];
        g = values[1];
        b = values[2];
        a = values[3] || 1;
        if (actualValue.r !== r || actualValue.g !== g || actualValue.b !== b || actualValue.a !== a) setActualValue({r: r, g: g, b: b, a: a});
      }
    }
    // setActualValue();
  }, [value]);

  return (<>
    {!!label && <Typography sx={{fontSize: '0.75rem'}}>{label}</Typography>}
    <Button aria-describedby="color_picker" variant="contained" sx={{backgroundColor: rgbValue}} onClick={(e) => {
      setAnchorEl(e.currentTarget);
    }}>{rgbValue}</Button>
    <Popover
      id="color_picker"
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={() => {setAnchorEl(null);}}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <ChromePicker
        color={actualValue}
        onChangeComplete={(c, e) => {
          setActualValue(c.rgb);
        }}
      />
    </Popover>
  </>);
}